import React from 'react';
import LoadingSpinner from '../../components/LoadingSpinner';
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage';
import PropTypes from 'prop-types';
import './Videos.css';
import { Link } from 'react-router-dom';


const Videos = props => {
    const {
        videos,
        loading,
        error
    } = props;

    if (error) {
        return <ErrorMessage />;
      }

    if (loading) {
        return <LoadingSpinner size="large" colorScheme="blue" />;
    }

    return (
        <section className="videos-overview-container">
            <header className="page-header">
                <h1>Videos</h1>
            </header>

            {videos && (
                <div className="videos-overview-cards-container container">
                    {videos.map((video, index) => (
                        <div className="video" key={index}>
                            <Link to={video.fields.url}>
                                <img src={video.fields.thumbnail} alt={video.fields.title}/>
                                <p>{video.fields.title}</p>
                            </Link>
                        </div>
                    ))}
                </div>
            )}
        </section>
    )
}

Videos.propTypes = {
    videos: PropTypes.array,
    error: PropTypes.bool,
    loading: PropTypes.bool.isRequired
};

Videos.defaultProps = {
    videos: null,
    error: false
};

export default Videos;



// WEBPACK FOOTER //
// ./src/containers/Videos/Videos.js